import React, { useState } from 'react';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const [hovered, setHovered] = useState(false);
  const phoneNumber = '51948156106';
  const message = encodeURIComponent('Hola, quiero hacer una reserva 🍽️');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`whatsapp-fab${hovered ? ' hovered' : ''}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="Chatea con nosotros en WhatsApp"
    >
      <span className="whatsapp-tooltip">
        <span className="whatsapp-tooltip-arrow" />
        Reserva ahora
      </span>

      {/* WhatsApp SVG Icon */}
      <svg
        className="whatsapp-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        aria-hidden="true"
      >
        <circle cx="24" cy="24" r="24" fill="#25D366" />
        <path
          fill="#fff"
          d="M34.6 13.4A14.9 14.9 0 0 0 24 9C16.3 9 10 15.3 10 23c0 2.5.7 4.9 1.9 7L10 39l9.3-2.4A15 15 0 0 0 24 38c7.7 0 14-6.3 14-14 0-3.7-1.5-7.2-3.4-10.6zM24 35.5c-2.2 0-4.3-.6-6.1-1.6l-.4-.3-4.4 1.1 1.2-4.2-.3-.5A12.4 12.4 0 0 1 11.6 23c0-6.8 5.6-12.4 12.4-12.4 3.3 0 6.4 1.3 8.7 3.6a12.3 12.3 0 0 1 3.7 8.8c0 6.8-5.6 12.4-12.4 12.4zm6.8-9.3c-.4-.2-2.2-1.1-2.6-1.2-.3-.1-.6-.2-.8.2-.3.4-.9 1.2-1.2 1.5-.2.3-.4.3-.8.1-.4-.2-1.6-.6-3-1.8a11 11 0 0 1-2.1-2.5c-.2-.4 0-.6.2-.8l.6-.7c.2-.2.2-.4.3-.6.1-.2 0-.5-.1-.7-.1-.2-.8-2-1.1-2.7-.3-.7-.6-.6-.8-.6h-.7c-.2 0-.6.1-.9.4-.3.4-1.2 1.2-1.2 2.9s1.3 3.3 1.4 3.5c.2.2 2.5 3.8 6 5.3.8.4 1.5.6 2 .7.8.3 1.6.2 2.2.1.7-.1 2.2-.9 2.5-1.7.3-.8.3-1.5.2-1.7-.1-.2-.3-.3-.7-.4z"
        />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
